<template>
  <div style="height: 100vh;overflow-y: scroll;" >
    <div style="display: flex;">
      <el-aside class="el-aside">
        <el-menu class="el-menu leftMenu" active-text-color="#000"  text-color="#6a6a6a" :default-openeds="['1']"
          :default-active="activeMenuItem" style="">
          <el-menu-item index="1-1" @click="label_evt('referenceSection' )">参考图标签 <span
              class="right_Ev">{{ this.tags.refer.total }}</span></el-menu-item>
          <el-menu-item index="1-2" @click="label_evt('personSection')">模型人标签<span
              class="right_Ev">{{ this.tags.model2.total }}</span></el-menu-item>
          <el-menu-item index="1-3" @click="label_evt('trafficSection')">模型交通标签<span
              class="right_Ev">{{ this.tags.model3.total }}</span></el-menu-item>
          <el-menu-item index="1-4" @click="label_evt('plant')">模型植物标签<span
              class="right_Ev">{{ this.tags.model1.total }}</span></el-menu-item>
          <el-menu-item index="1-5" @click="label_evt('Home_Furnishing')">模型家居标签<span
              class="right_Ev">{{ this.tags.model4.total }}</span></el-menu-item>
          <el-menu-item index="1-6" @click="label_evt('scene')">模型场景标签<span
              class="right_Ev">{{ this.tags.model6.total }}</span></el-menu-item>
          <el-menu-item index="1-7" @click="label_evt('PSpeople')">PS人标签<span
              class="right_Ev">{{ this.tags.ps1.total }}</span></el-menu-item>
          <el-menu-item index="1-8" @click="label_evt('PSplant')">PS植物标签<span
              class="right_Ev">{{ this.tags.ps2.total }}</span></el-menu-item>
        </el-menu>
      </el-aside>
      <div style="width: 90%; margin-top: 60px;" ref="rightContent" >
        <div id="form" style="position: fixed;background: #fff;width: 80%;margin-left: 200px;"
          class="min">
          <div style="margin-top: 5px ; margin-left: 10px;height:40px;">
            <span @click="cleanUpEvt" class="all_text">All</span>
            <el-date-picker v-model="value2" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"
              align="right" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="timestamp"
              range-separator="-" style="width: 240px;margin-top: 5px;" @change="getList" class="border_box"
              :class="{ 'your-css-class': !isValue2Empty }"></el-date-picker>
          </div>
        </div>

        <div class="Reference" id="referenceSection" ref="referenceSection"
          style="margin-top: 40px;margin-left: 200px;">
          <span style="font-size:14px;">
            <span style="margin-left: 10px;">参考图标签 </span> 总计
            <span style="color: #409eff;">{{ this.tags.refer.total }}</span>
          </span>
          <div style="  display: flex; ">
            <div v-for="item in tags.refer.tags" :key="item.id" class="containerr">
              <div>
                {{ item.title }}
              </div>
              <div v-for="res in item.children" :key="res.id" :style="{ backgroundColor: res.rgb }">
                <span>{{ res.title }}</span>
                <span style="color: #000;margin-left: 10px">{{ res.num }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="person" id="personSection" style="margin-left: 260px;margin-top: 20px;">
          <div style="font-size:14px;">
            <span style="margin-left: 10px;">模型人标签 </span> 总计
            <span style="color: #409eff;">{{ this.tags.model2.total }}</span>
          </div>
          <div style="display: flex;">
            <div v-for="item in tags.model2.tags" class="containerr" :key="item.id">
              <div>{{ item.title }}</div>
              <div v-for="res in item.children" :key="res.id" :style="{ backgroundColor: res.rgb }">
                <span> {{ res.title }}</span>
                <span style="color: #000;margin-left: 10px">{{ res.num }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="traffic" id="trafficSection" style="margin-left: 260px;margin-top: 20px;">
          <div style="font-size:14px;">
            <span style="margin-left: 10px;">模型交通标签 </span> 总计
            <span style="color: #409eff;">{{ this.tags.model3.total }}</span>
          </div>
          <div style="display: flex;">
            <div v-for="item in tags.model3.tags" class="containerr" :key="item.id">
              <div>{{ item.title }}</div>
              <div v-for="res in item.children" :key="res.id" :style="{ backgroundColor: res.rgb }">
                <span> {{ res.title }}</span>
                <span style="color: #000;margin-left: 10px">{{ res.num }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="traffic" id="plant" style="margin-left: 260px;margin-top: 20px;">
          <div style="font-size:14px;">
            <span style="margin-left: 10px;">模型植物标签 </span> 总计
            <span style="color: #409eff;">{{ this.tags.model1.total }}</span>
          </div>
          <div style="display: flex;">
            <div v-for="item in tags.model1.tags" class="containerr" :key="item.id">
              <div>{{ item.title }}</div>
              <div v-for="res in item.children" :key="res.id" :style="{ backgroundColor: res.rgb }">
                <span> {{ res.title }}</span>
                <span style="color: #000;margin-left: 10px">{{ res.num }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="traffic" id="Home_Furnishing" style="margin-left: 260px;margin-top: 20px;">
          <div style="font-size:14px;">
            <span style="margin-left: 10px;">模型家居标签 </span> 总计
            <span style="color: #409eff;">{{ this.tags.model4.total }}</span>
          </div>
          <div style="display: flex;">
            <div v-for="item in tags.model4.tags" class="containerr" :key="item.id">
              <div>{{ item.title }}</div>
              <div v-for="res in item.children" :key="res.id" :style="{ backgroundColor: res.rgb }">
                <span> {{ res.title }}</span>
                <span style="color: #000;margin-left: 10px">{{ res.num }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="traffic" id="scene" style="margin-left: 260px;margin-top: 20px;">
          <div style="font-size:14px;">
            <span style="margin-left: 10px;">模型场景标签 </span> 总计
            <span style="color: #409eff;">{{ this.tags.model6.total }}</span>
          </div>
          <div style="display: flex;">
            <div v-for="item in tags.model6.tags" class="containerr" :key="item.id">
              <div>{{ item.title }}</div>
              <div v-for="res in item.children" :key="res.id" :style="{ backgroundColor: res.rgb }">
                <span> {{ res.title }}</span>
                <span style="color: #000;margin-left: 10px">{{ res.num }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="traffic" id="PSpeople" style="margin-left: 260px;margin-top: 20px;">
          <div style="font-size:14px;">
            <span style="margin-left: 10px;">PS人标签 </span> 总计
            <span style="color: #409eff;">{{ this.tags.ps1.total }}</span>
          </div>
          <div style="display: flex;">
            <div v-for="item in tags.ps1.tags" class="containerr" :key="item.id">
              <div>{{ item.title }}</div>
              <div v-for="res in item.children" :key="res.id" :style="{ backgroundColor: res.rgb }">
                <span> {{ res.title }}</span>
                <span style="color: #000;margin-left: 10px">{{ res.num }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="traffic" id="PSplant" style="margin-left: 260px;margin-top: 20px;">
          <div style="font-size:14px;">
            <span style="margin-left: 10px;">PS植物标签 </span> 总计
            <span style="color: #409eff;">{{ this.tags.ps2.total }}</span>
          </div>
          <div style="display: flex;">
            <div v-for="item in tags.ps2.tags" class="containerr" :key="item.id">
              <div>{{ item.title }}</div>
              <div v-for="res in item.children" :key="res.id" :style="{ backgroundColor: res.rgb }">
                <span> {{ res.title }}</span>
                <span style="color: #000;margin-left: 10px">{{ res.num }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="traffic" id="kongbai">
          <div style="height: 300px;"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getIcoMeLabelApi } from "../../../apis/income";

export default {
  data() {
    return {
      activeMenuItem:'1-1',
      openeds: ["1"],
      type:1,
      header: true,
      total:null,
      src:
        "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
      //备注
      remtInput: "",
      authorIdInput: "",
      localInput: "",
      last_login: "",
      //分页输入框数据
      paginationInput: 10,
      currentPage1: 1,

      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
              picker.$emit("pick", [
                new Date(start.setHours(0, 0, 0, 0)),
                new Date(end.setHours(23, 59, 59, 0))
              ]);
            }
          },
          {
            text: "本周",
            onClick(picker) {
              const current = new Date();
              let nowDayOfWeek = current.getDay();
              if (nowDayOfWeek === 0) nowDayOfWeek = 7;
              const dayNum = 1 * 24 * 60 * 60 * 1000;
              const firstDate = new Date(
                current.valueOf() - (nowDayOfWeek - 1) * dayNum
              );
              const lastDate = new Date(
                new Date(firstDate).valueOf() + 6 * dayNum
              );
              // picker.$emit("pick", [firstDate, lastDate]);
              picker.$emit("pick", [
                new Date(firstDate.setHours(0, 0, 0, 0)),
                new Date(lastDate.setHours(23, 59, 59, 0))
              ]);
            }
          },
          {
            text: "当月",
            onClick(picker) {
              const date = new Date();
              const year = date.getFullYear();
              const month = date.getMonth();
              let thisMonthStartDate = new Date(year, month, 1);
              let thisMonthEndDate = new Date(year, month + 1, 0);
              // picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
              picker.$emit("pick", [
                new Date(thisMonthStartDate.setHours(0, 0, 0, 0)),
                new Date(thisMonthEndDate.setHours(23, 59, 59, 0))
              ]);
            }
          },
          {
            text: "当年",
            onClick(picker) {
              var tYear = new Date().getFullYear();
              var startTime = new Date(tYear, 0, 1); //当前年第一天
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              // picker.$emit("pick", [startTime, endTime]);
              picker.$emit("pick", [
                new Date(startTime.setHours(0, 0, 0, 0)),
                new Date(endTime.setHours(23, 59, 59, 0))
              ]);
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const temp = new Date();
              temp.setTime(temp.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [
                new Date(temp.setHours(0, 0, 0, 0)),
                new Date(temp.setHours(23, 59, 59, 0))
              ]);
            }
          },
          {
            text: "上周",
            onClick(picker) {
              const current = new Date(
                new Date().getTime() - 60 * 60 * 24 * 7 * 1000
              );
              let nowDayOfWeek = current.getDay();
              let diffToMonday =
                current.getDate() -
                nowDayOfWeek +
                (nowDayOfWeek === 0 ? -6 : 1);
              const firstDate = new Date(current.setDate(diffToMonday));
              const lastDate = new Date(current.setDate(diffToMonday + 6));
              picker.$emit("pick", [
                new Date(firstDate.setHours(0, 0, 0, 0)),
                new Date(lastDate.setHours(23, 59, 59, 0))
              ]);

              // picker.$emit("pick", [firstDate, lastDate]);
            }
          },
          {
            text: "上月",
            onClick(picker) {
              var now = new Date();
              var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
              var ed = new Date(now.getFullYear(), now.getMonth(), 0);
              picker.$emit("pick", [fd, ed]);
            }
          },
          {
            text: "去年",
            onClick(picker) {
              var tYear = new Date().getFullYear() - 1;
              var startTime = new Date(tYear, 0, 1);
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            }
          }
        ]
      },
      value1: "",
      value2: "",
      levelName: "等级",
      adminuser: null,
      vipName: "会员情况",
      member: null,
      effectiveName: "有效性",
      okAndNo: null,
      RechargeName: "点数情况",
      recharge: null,
      registerName: "注册来源",
      laiyuan: null,
      input: "",
      editShowInp: null,
      editName: null,
      tableData: [],
      totalRow: null,
      //排序
      order: null,
      orField: null,
      activeId: null,
      deleteVisible: false,
      data: {},
      num: null,
      count: 0,
      pagefenye: false, //点击分页 滚动条为0
      loading: false,
      items: [],
      itemss: [],
      tags: [],
      tages: [],
      tableData1: [],
      isValue2Empty: true,
      c:1,
    };
  },
  created() {
    this.loading = true;
    if (this.$store.getters.location == '') {
      this.c = 1
    }
    this.c = this.$store.getters.location;
    getIcoMeLabelApi({c:this.c}).then(res => {
      this.items = res.data;
      this.itemss = res.data;
      this.tags = res.data;
      this.loading = false;
    });
    //监听鼠标按下抬起事件
    window.addEventListener("keydown", this.handKeyCode, true);
    window.addEventListener("keyup", this.handKeyEvt);
  },
  beforeDestroy() {
    // 在组件生命周期结束的时候销毁
    window.removeEventListener("keydown", this.handKeyCode, false);
    window.removeEventListener("keyup", this.handKeyEvt, false);
  },
  mounted() {
    //监听页面滚动条事件
    window.addEventListener("scroll", e => this.imgScrollEvt(e), true);
    this.c = this.$store.getters.location;
  },

  methods: {
    label_evt(sectionId){
      const rightContent = this.$refs.rightContent; // 获取容器的引用
      const sectionElement = document.getElementById(sectionId);
      if (rightContent && sectionElement) {
        // 确保右侧容器和目标区域元素都存在
        const containerRect = rightContent.getBoundingClientRect();
        const sectionRect = sectionElement.getBoundingClientRect();

        // 计算滚动的目标位置（顶部位置减去 100px）
        const scrollPosition = sectionRect.top

        // 只有当目标区域在右侧容器内部时，才执行滚动操作
        if (scrollPosition >= containerRect.top && sectionRect.bottom <= containerRect.bottom) {
          // 使用新的滚动位置
          sectionElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    },

    //按下键盘事件
    handKeyCode(e) {
      e = e || window.event;
    },
    limitEvt() {
      this.getList();
    },
    //滑动事件
      imgScrollEvt() {
        const form = document.getElementById('form');
        const referenceSection = document.getElementById('referenceSection');
        if (referenceSection) {
          const rectRef = referenceSection.getBoundingClientRect();
          this.$nextTick(()=>{
            if (rectRef.top == 100) {
              this.activeMenuItem = '1-1'; // Update activeMenuItem when form's bottom covers referenceSection's bottom
            }
          })
        }
        const sectionsToCheck = [
          { section: document.getElementById('personSection'), menuItem: '1-2' },
          { section: document.getElementById('trafficSection'), menuItem: '1-3' },
          { section: document.getElementById('plant'), menuItem: '1-4' },
          { section: document.getElementById('Home_Furnishing'), menuItem: '1-5' },
          { section: document.getElementById('scene'), menuItem: '1-6' },
          { section: document.getElementById('PSpeople'), menuItem: '1-7' },
          { section: document.getElementById('PSplant'), menuItem: '1-8' },
          { section: document.getElementById('kongbai'), menuItem: '1-8' },
        ];
        sectionsToCheck.forEach(({ section, menuItem }) => {
          if (section) {
            const rect = section.getBoundingClientRect();
            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
              this.activeMenuItem = menuItem;
            }
          }
        });
      },
    ///获取页面数据
    getList() {
      this.loading =  true;
      let date = {
        start: this.value2[0],
        end: this.value2[1]
      };
      var start = Math.floor(date.start / 1000);
      var end = Math.floor(date.end / 1000);
      // 将选定的日期转换为当天的最后一秒
      var lastVaccineDate = new Date(end * 1000);
      lastVaccineDate.setHours(23, 59, 59);
      var endTimestamp = Math.floor(lastVaccineDate.getTime() / 1000);
      getIcoMeLabelApi({
        start: start,
        end: endTimestamp,
        c:this.c
      }).then(res => {
        this.items = res.data
        this.itemss = res.data
        this.tags = res.data
        this.loading = false
      });
    },
    //分页
    handleCurrentChange(res) {
      this.loading = true;
      setTimeout(() => {
        this.getList();
        this.loading = false;
      }, 500);
    },
    //
    rowStyle({ row, column, rowIndex, columnIndex }) {
      if (column.label == "等级") {
        return {};
      } else if (column.label == "昵称") {
        return {};
      }
    },
    //列表排序
    sortChangeEvt(row) {
      if (row.order == "ascending") {
        this.order = "asc";
      } else if (row.order == "descending") {
        this.order = "desc";
      }
      this.orField = row.prop;
      this.getList();
    },
    //显示修改输入框
    editShowEvt(e, s) {
      this.editShowInp = e.id;
      this.editName = s;
      this.$nextTick(_ => {
        this.$refs.editInput.$refs.input.focus();
      });
    },

    //清除搜索条件
    cleanUpEvt() {
      this.loading = true;
      this.value2 = "";
      getIcoMeLabelApi({c:this.c}).then(res => {
        this.items = res.data
        this.itemss = res.data
        this.tags = res.data
        this.loading = false;
      });
    }
  },
  watch: {
    '$store.getters.location': function (newLocation, oldLocation) {
      this.c = newLocation
    },
    //修改选中日期的背景颜色
    value2: function(newVal, oldVal) {
      this.isValue2Empty = !newVal;
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../../../style/income.less");
/deep/.el-header{
  position: fixed !important;
}
.income_header {
  height: 35px;
  display: flex;
  align-items: center;

  span {
    font-size: 14px;
    margin-left: 20px;
  }
}
.containerr {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  width: 120px;
  margin: 5px;
  div {
    // margin-top: 10px;
    display: flex;
    justify-content: space-between;
    padding: 5px;
  }
}

.container {
  /* 添加你想要的container样式 */
  white-space: nowrap;
  display: flex;
}

.container div {
  /* 添加你想要的子元素div样式 */
  display: flex;
  align-items: center;
  margin-right: 10px;
  /* 可根据需要调整间距 */
  font-size: 14px;
}

.container div .number {
  color: #f00;
  /* 数字的默认颜色 */
}

table {
  width: 100%;
}

th,
td {
  border: 1px solid black;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #f2f2f2;
}

.item {
  margin-top: 10px;
}

/deep/.el-input__suffix {
  color: #409eff;
}

/deep/.el-main {
  overflow: none !important;
}

.all_text {
  background-color: #409eff;
  font-size: 13px;
  color: #fff;
  cursor: pointer;
  padding: 5px 20px;
  border-radius: 3px;
  width: 50px;
}

.block {
  position: fixed;
  right: calc(100% - 99.4%);
  top: 60px;
}

.block1 {
  visibility: hidden;
}

.block1 > div {
  display: none;
}

.demo-table-expand {
  background-color: #f2f2f2;
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  padding: 0 20px;
  width: 30%;
}

.name_box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  i {
    cursor: pointer;
    display: none;
  }
}

.name_box:hover > i {
  display: block;
}

.pagination_box {
  min-width: 500px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.num_box button {
  width: 125px;
  border: none;
  background-color: #fff;
  color: #c4c3c3;
}

.rowClassOne {
  background-color: #e7ecff;
}

.rowClassTwo {
  color: #222222;
  background-color: #1c43ce;
}

.rowClassThree {
  background-color: #6a88f1;
}

.el-dropdown-link {
  cursor: pointer;
}

.notes_box {
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.my-icon {
  cursor: pointer;
  width: 25px;
}

/deep/.el-table thead {
  font-size: 12px;
}

/deep/.el-input__inner {
  color: #409eff;
  cursor: pointer;
}

.clear_ev {
  position: absolute;
  right: 10px;
}

.vip-button {
  color: #409eff !important;
}

/* 朝上排序样式 */
/deep/.el-table .ascending .sort-caret.ascending {
  background-color: #f00 !important;
  background: url("../../../img/top1.png") no-repeat -4px -3px  !important;
  background-size: 20px 20px !important;
  width: 40px;
  height: 58px;
  z-index: 11;
}
/* 朝下排序样式 */
/deep/.el-table .descending .sort-caret.descending {
  background: url("../../../img/bottom1.png") no-repeat -5px 2px !important;
  background-size: 20px 20px !important;
  width: 40px;
  height: 25px;
}
/deep/.el-table .descending .sort-caret.descending {
  border-top-color: #fff;
}
/* 朝上字体样式 */
/deep/.el-table__header .ascending .cell {
  color: #409EFF!important;
}
/* 朝下字体样式 */
/deep/.el-table__header .descending .cell {
  color: #409EFF!important;
}

.your-css-class {
  background-color: #bcd9f8d4 !important;
  z-index: 9999;
  input {
    background-color: #bcd9f8d4 !important;
  }
}
/deep/.el-icon-circle-close:before {
  content: "" !important;
  display: none;
}
.el-aside {
  width: 10% !important;
  max-width: 260px !important;
  min-width: 180px !important;
  min-height: calc(100vh - 60px);
  border-right: 1px solid #e5e5e5;
  position: fixed;
  margin-top: 60px;
}

.right-content {
  overflow-y: auto;
  /* Enable scrolling for the right content */
  height: 100vh;
  /* Adjust as needed */
}



.right_Ev{
 color: #409eff;
 position: absolute;
 right: 20px;
 font-size: 12px;
}
.el-menu-item{
  height: 30px !important;
  line-height: 30px !important  ;
  font-size: 12px ;
  margin: 0px 5px !important;
}
.el-menu-item:nth-child(1){
  margin-top:10px !important
}
.el-aside .is-active{
  border-radius: 8px;
    background-color: #F0F0F0;
    color: #373535;
}


.el-menu-item:focus,
.el-menu-item:hover {
  border-radius: 8px;
  background-color:#fff !important;
}
  .leftMenu .el-menu-item.is-active{
    background-color: #F0F0F0 !important;
  }

  @media screen and (min-width:1921px)and (max-width: 2560px) {
    .min{
      margin-left: 260px !important;
    }
    .Reference {
      margin-left: 260px !important;
    }
  }
  @media screen and (min-width: 2561px)and (max-width: 3440px) {
  .Reference {
    margin-left: 260px !important;
  }
  .min{
      margin-left: 260px !important;
    }
}
  

</style>
<style>
.your-css-class .el-range-input {
  background-color: #8fc6ff00 !important;
}
::placeholder {
  color: #858585 !important;
}
.border_box {
  border: 1px solid #858585;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/Label_quantity/components/Reference_statistics/index.vue